type Config = Partial<{ minScale: number, maxScale: number }>

export function formatNumber<T extends number|null|undefined>(value: T): string
export function formatNumber<T extends number|null|undefined>(value: T, config: Config): string
export function formatNumber<T extends number|null|undefined>(value: T, fallback: string): string
export function formatNumber<T extends number|null|undefined>(value: T, fallback: string, config: Config): string
export function formatNumber<T extends number|null|undefined>(value: T, fallback: Config|string = '', config: Config = { }): string {
  if (typeof fallback !== 'string') {
    config = fallback
    fallback = ''
  }

  const { minScale = 2, maxScale = 5 } = config

  const numberFormatter = new Intl.NumberFormat('en-US',
    {
      useGrouping: true,
      minimumFractionDigits: minScale,
      maximumFractionDigits: maxScale
    }
  )

  return (typeof value === 'number')
    ? numberFormatter.format(value).replace(/,/g, ' ')
    : fallback
}
